module.exports = __webpack_public_path__ + "static/img/xh1.dc6ce9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xh1.png
// module id = +6ko
// module chunks = 0